import type { FieldReadFunction } from "@apollo/client";

/** Apollo may store list fields as arrays or numeric-keyed ref maps. */
export function asMessageContentRefList(value: unknown): readonly unknown[] {
  if (value == null) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === "object") {
    const record = value as Record<string, unknown>;
    const keys = Object.keys(record)
      .filter((k) => /^\d+$/.test(k))
      .sort((a, b) => Number(a) - Number(b));
    return keys.map((k) => record[k]);
  }
  return [];
}

/**
 * Replace MessageObject.content on fragment/query writes. Incoming rows fully
 * replace prior refs so content cannot accumulate across messages or turns.
 *
 * Incremental streaming MUST use cache.modify on the message (see
 * upsertStreamingContentOnMessage) — that path bypasses this merge function.
 */
export function mergeMessageObjectContent(
  existing: unknown,
  incoming: unknown,
  _readField: FieldReadFunction,
): unknown {
  const next = asMessageContentRefList(incoming);
  if (next.length === 0) {
    const prior = asMessageContentRefList(existing);
    return prior.length > 0 ? prior : next;
  }
  return next;
}
